import React,{useEffect, useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { sidebarAction } from '../redux/SidebarSlice'
import BreadCrames from '../component/BreadCrames';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import ApiConnection, { BaseUrl } from '../utils/ApiConnection';
import Loader from '../utils/Loader';
import moment from 'moment';
import { toast } from 'react-toastify';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const CompleteRide = () => {
  const [triplist, settriplist] = useState([])
  const [loading, setloading] = useState(false)

  
    const dispatch = useDispatch()
    const GetTrip = async () =>{

      setloading(true)

      try {

          const response = await ApiConnection.get('trips?status=completed')
          setloading(false)
          if(response?.status === 200) {
              settriplist(response?.data?.data?.list)
          }

      } catch (e){  setloading(false)}

  }

    useEffect(()=>{
      GetTrip()
        dispatch(sidebarAction(false)) 
      },[])

  return (
    <>
     {loading && <Loader/>}
    <BreadCrames page="Complete Trip" />
    <div className='px-4'>
    {triplist&&triplist.length > 0 ?
      

      <div className='row'>
        {triplist&&triplist.map((item, index)=>{
          return (
            <div className='col-lg-6' key={index}>
            <div className='card mb-3'>
              <div className='card-body'>
                        <p>
                          <b>Name: </b>
                          {item?.customer?.first_name} {item?.customer?.last_name} ({item?.customer?.phone})                                                     
                        </p>
                        <p>
                          <b>Pickup Location: </b>
                          {item?.pickup_location}                                                        
                        </p>
                        <p>
                          <b>Date & Time of Pickup: </b>
                          {moment(item?.pickup_date).format('DD-MM-YYY LT')}                                                     
                        </p>
                        <p>
                          <b>Drop Location: </b>
                         {item?.drop_location}                                                      
                        </p>
                        <p>
                          <b>Car Type: </b>
                         {item?.cartype}                                                      
                        </p>
                        <p>
                          <b>Final Fare: </b>
                        $ {item?.final_fare}                                                      
                        </p>
                        <p>
                          <b>Status: </b>
                         {item?.status == 4 ? 
                         <span className='text-danger'>Cancelled</span> 
                         : item?.status == 3 ?
                         <span className='text-success'>Completed</span> 
                         :
                         item?.status == 2 ? 
                         <span className='text-info'>Declined</span> 
                         :
                         item?.status == 1 ? 
                         <span className='text-primary'>Accepted</span> 
                         :
                         <span className='text-warning'>Pending</span> 
                        }                                                      
                        </p>
                        <b>Cutomer Details: </b>
                        <div className='customer-details'>
                          {item?.
customer?.image == null ?
<FontAwesomeIcon icon={faUserTie} />
:
<img src={BaseUrl + item?.
customer?.image} />
}
                       
                        <h5>{item?.
customer?.first_name + ' ' + item?.
customer?.last_name} ({item?.
  customer?.country_code +' ' + item?.
  customer?.phone})</h5>
                          </div>
                    </div>
                  </div>
              </div>
          )
        })}
    
        
        
        </div>
        :
        <h5>No Trip list</h5>
  }
  
    </div>
 
</>
  )
}

export default CompleteRide